<template>
    <ul class="list px-0">
        <div class="list-item" >
            <div :key="editedElementId + propertyName"
                 v-for="(value, propertyName, index) in element">
                <object-value-content :path="path + '.' + propertyName"
                                      :propName="propertyName"
                                      :element="value"
                                      v-if="showField(propertyName)">
                </object-value-content>
                <div  v-else-if="propName === 'style'">
                    <object-value :objValue="value"
                                  :propertyName="propertyName"
                                  :parentPropName="propName"
                                  :key="editedElementId + propertyName"
                                  :path="path"
                                  @deleteProp="deleteProperty"></object-value>
                </div>
                <div class="input-group input-group-sm  mb-1"
                     v-else-if="propertyName === 'isImage'">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            Is this an image ?
                        </span>
                    </div>
                    <div class="input-group-append d-flex align-items-center ml-4"
                         :key="editedElementId">
                        <input type="checkbox" id="isImage"
                               v-model="element.isImage"
                               @change="toggleSource">
                    </div>
                </div>
                <div class="input-group input-group-sm  mb-1"
                     v-else-if="propertyName === 'editable'">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            Is this an editable element ?
                        </span>
                    </div>
                    <div class="input-group-append d-flex align-items-center ml-4"
                         :key="editedElementId">
                        <input type="checkbox"
                               id="editable"
                               v-model="element.editable"
                               @change="toggleEditable">
                    </div>
                </div>
            </div>
            
            <div class="py-2" v-if="propName === 'style'">
                <strong>Add new style:</strong>
                <css-prop :selectedProp="selectedProp"
                          :value="selectedPropValue"
                          :mode="'add'" :newProperty="true"
                          :key="editedElementId"
                          @addStyle="addStyle"
                          @selectedProperty="selectedProp = $event"
                          @newValue="selectedPropValue = $event.value"/>
            </div>
        </div>
    </ul>
</template>

<script type="text/babel">
import ObjectValue from './ObjectValue.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import IdGetterMixin from './IdGetterMixin';
import CssProp from './CssProp/CssProp.vue';

export default {
    name: 'ObjectValueContent',
    data () {
        return {
            fromWatcher: false,
            expanded: true,
            selectedProp: {},
            newProperty: '',
            selectedPropValue: '',
            newPropertyValue: ''
        };
    },
    props: ['element', 'propName', 'path'],
    computed: {
        ...mapGetters({
            rootPath: 'getEditedElementRootPath',
            editedElementId: 'getEditedElementId',
            editedElement: 'getEditedElement'
        }),
        completePath () {
            return `${this.rootPath}${this.path}`;
        }
    },
    components: {
        ObjectValue,
        CssProp
    },
    mixins: [IdGetterMixin],
    methods: {
        ...mapMutations(['addMetaData']),
        ...mapActions(['deleteMetadataAction']),
        hasNestedProps (el) {
            if((typeof el).toLowerCase() === 'object') {
                return Object.keys(el).length >= 1;
            } else {
                return false;
            }
        },
        addStyle (event) {
            this.updateMetadataSource(event.prop);
            this.$vuexSet(
                this.sanitizePath(`currentLayout.${this.rootPath}${this.path}.${event.prop}`),
                event.value
            );
            this.selectedPropValue = '';
            this.selectedProp = {};
        },
        toggleSource () {
            this.$vuexSet(
                this.sanitizePath(`currentLayout.${this.rootPath}${this.path}.isImage`),
                this.editedElement.isImage
            );
    
            if(this.editedElement.isImage) {
                this.addMetaData({
                    id: this.editedElementId,
                    //eslint-disable-next-line
                    src: `style['background-image']`,
                    url: true
                });
            } else {
                this.deleteMetadataAction(this.editedElement);
            }
        },
        toggleEditable () {
            this.$vuexSet(
                this.sanitizePath(`currentLayout.${this.rootPath}${this.path}.editable`),
                this.editedElement.editable
            );
        },
        showField (propertyName) {
            return propertyName === 'attrs' || propertyName === 'style';
        },
        deleteProperty (propName) {
            this.$vuexSet(`editedElement${this.path}.${propName}`, null);
            this.$delete(this.element, propName);
            this.$vuexSet(
                this.sanitizePath(`currentLayout.${this.rootPath}${this.path}`),
                this.element
            );
            this.$vuexSet(`editedElement${this.path}`, this.element);
        }
    }
};

</script>

<style lang="scss">
    div.list-item {
        width: 100%;
    }
</style>
